import { render, staticRenderFns } from "./request-message-chat.scene.vue?vue&type=template&id=631e718a"
import script from "./request-message-chat.scene.ts?vue&type=script&lang=ts&external"
export * from "./request-message-chat.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./request-message-chat.style.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VDialog,VSnackbar})
